export default __webpack_public_path__ + "static/main8-table-480-6aa6b79455dcd3b62e924ee3d8962519.png";